export default __webpack_public_path__ + "static/flammable_w.ffc7208c6d3c711f38d595ecc710a5f8.png";